module.exports = __webpack_public_path__ + "img/gmail-image.4d3fffd4.png";